// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pH-z","twoColumnImage":"qH-z"};